"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityService = void 0;
const dateUtils_1 = require("../utils/dateUtils");
class ActivityService {
    /**
     * Get activity title based on type
     */
    static getActivityTitle(activity) {
        var _a, _b;
        switch (activity.type) {
            case 'movie_watched':
                if (activity.rating && ((_a = activity.metadata) === null || _a === void 0 ? void 0 : _a.movieTitle)) {
                    return `You watched and rated ${activity.rating}/5`;
                }
                else {
                    return 'You watched';
                }
            case 'movie_added_to_list':
                return 'You want to watch';
            case 'watchlist_liked':
                return 'You liked a watchlist';
            case 'user_followed':
                return 'You followed a user';
            case 'watchlist_shared':
                const shareMethod = (_b = activity.metadata) === null || _b === void 0 ? void 0 : _b.shareMethod;
                if (shareMethod === 'email') {
                    return 'You shared a watchlist via email';
                }
                else if (shareMethod === 'social') {
                    return 'You shared a watchlist on social media';
                }
                else {
                    return 'You shared a watchlist';
                }
            case 'collaborator_added':
                return 'You added a collaborator to your watchlist';
            case 'watchlist_created':
                return 'You created a watchlist';
            case 'review_posted':
                if (activity.rating) {
                    return `You reviewed and rated ${activity.rating}/5`;
                }
                else {
                    return 'You posted a review';
                }
            default:
                return 'Activity';
        }
    }
    /**
     * Format relative time for activity dates
     */
    static formatActivityDate(date) {
        const now = new Date();
        const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);
        if (diffInSeconds < 60) {
            return 'just now';
        }
        else if (diffInSeconds < 3600) {
            const minutes = Math.floor(diffInSeconds / 60);
            return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
        }
        else if (diffInSeconds < 86400) {
            const hours = Math.floor(diffInSeconds / 3600);
            return `${hours} hour${hours > 1 ? 's' : ''} ago`;
        }
        else if (diffInSeconds < 604800) {
            const days = Math.floor(diffInSeconds / 86400);
            return `${days} day${days > 1 ? 's' : ''} ago`;
        }
        else {
            // For older dates, show actual date
            return (0, dateUtils_1.formatFirebaseDate)(date, 'Recently', {
                month: 'short',
                day: 'numeric',
                year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
            });
        }
    }
    /**
     * Create default movie object for activities
     */
    static createDefaultMovie(activity) {
        var _a, _b;
        return {
            id: 0,
            title: "Unknown Movie",
            original_title: "Unknown Movie",
            release_date: "",
            year: "",
            overview: "",
            poster_path: null,
            backdrop_path: null,
            genre_ids: [],
            adult: false,
            video: false,
            original_language: "en",
            popularity: 0,
            vote_average: 0,
            vote_count: 0,
            // TMDb compatibility
            Title: ((_a = activity.metadata) === null || _a === void 0 ? void 0 : _a.movieTitle) || "Unknown Movie",
            Year: "2023",
            imdbID: activity.movieId || '',
            Poster: ((_b = activity.metadata) === null || _b === void 0 ? void 0 : _b.moviePoster) || "N/A",
            Response: "True"
        };
    }
    /**
     * Get activity type category for rendering
     */
    static getActivityCategory(type) {
        switch (type) {
            case 'movie_watched':
            case 'movie_added_to_list':
            case 'review_posted':
            case 'movie_rated':
                return 'movie';
            case 'watchlist_liked':
            case 'watchlist_shared':
            case 'collaborator_added':
            case 'watchlist_created':
            case 'list_created':
                return 'watchlist';
            case 'user_followed':
                return 'user';
            default:
                return 'other';
        }
    }
    /**
     * Check if activity is movie-related
     */
    static isMovieActivity(activity) {
        return this.getActivityCategory(activity.type) === 'movie';
    }
    /**
     * Check if activity is watchlist-related
     */
    static isWatchlistActivity(activity) {
        return this.getActivityCategory(activity.type) === 'watchlist';
    }
    /**
     * Check if activity is user-related
     */
    static isUserActivity(activity) {
        return this.getActivityCategory(activity.type) === 'user';
    }
}
exports.ActivityService = ActivityService;
